// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.filterWrapper {
    background-color: #fff;
    border-radius: 10px;
    padding: 24px;
    margin: 24px;
}
.filterWrapper >div{
    display: grid;
    grid-template-columns: repeat(4, 1fr);
    gap: 20px 16px;
}

.dailyAttendanceSheetWrapper{
  background-color: #fff;
  border-radius: 10px;
  padding: 24px;
  margin: 24px;
}

.submitBtnWrapper{
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    margin: 30px 10px;
    gap: 16px;
}

.headerEdit, .headerLogs{
    display: flex;
    align-items:center;
    gap: 12px;
  }
  .headerEdit >p{
    margin-bottom: 0px;
    font-size: 20px;
    font-weight: 600;
  }
  
  .headerLogs >p{
    margin-bottom: 0px;
    font-size: 20px;
    font-weight: 600;
  }
  
  .headerEdit >:nth-child(1){
    width: 36px;
    height: 36px;
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: rgba(24, 144, 255, 0.1);
    border-radius: 20px;
  }
  .headerLogs>:nth-child(2){
    cursor: pointer;
    text-decoration: underline;
    color: var(--supportRed);
  }

  .tabAccessTableWrapper > table{
      width: 100%;
      table-layout: fixed;
      overflow-x: auto;
      border-radius: 10px !important;

  }

  .tabAccessTableWrapper > table td {
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    border: 1px solid var(--lightBlue);
    text-align: center;
  }
  
  .tabAccessTableWrapper > table > tbody td {
    font-weight: 600;
    padding: 10px 8px;
  }

/* --------------- Media Query ------------------ */
@media (max-width:1300px) {
    .filterWrapper >div{
        grid-template-columns: repeat(3, 1fr);
    }    
    .tabAccessTableWrapper > table{
      width: 100%;
  }
}
@media (max-width:1000px) {
    .filterWrapper >div{
        grid-template-columns: repeat(2, 1fr);
    }    
    .tabAccessTableWrapper > table{
      width: 100%;
  }
  .tabAccessTableWrapper {
    overflow-x: auto;
    padding: 10px;
    display: block;
  }
  .tabAccessTableWrapper >table{
   width: 100%;
  }
  .tabAccessTableWrapper p{
    font-size: 14px !important;
  }
}

@media (max-width:750px) {
  .filterWrapper {
    background-color: #fff;
    border-radius: 10px;
    padding: 10px;
    margin: 10px;
}

.dailyAttendanceSheetWrapper{
  padding: 10px;
  margin: 10px;
}
.tabAccessTableWrapper > table > tbody td {
  font-size: 14px !important;
}
}

@media (max-width:450px) {
  .filterWrapper >div{
    grid-template-columns: repeat(1, 1fr);
  }    
}`, "",{"version":3,"sources":["webpack://./src/components/AssignEquipmentSupervisor/user.css"],"names":[],"mappings":"AAAA;IACI,sBAAsB;IACtB,mBAAmB;IACnB,aAAa;IACb,YAAY;AAChB;AACA;IACI,aAAa;IACb,qCAAqC;IACrC,cAAc;AAClB;;AAEA;EACE,sBAAsB;EACtB,mBAAmB;EACnB,aAAa;EACb,YAAY;AACd;;AAEA;IACI,aAAa;IACb,eAAe;IACf,uBAAuB;IACvB,iBAAiB;IACjB,SAAS;AACb;;AAEA;IACI,aAAa;IACb,kBAAkB;IAClB,SAAS;EACX;EACA;IACE,kBAAkB;IAClB,eAAe;IACf,gBAAgB;EAClB;;EAEA;IACE,kBAAkB;IAClB,eAAe;IACf,gBAAgB;EAClB;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,yCAAyC;IACzC,mBAAmB;EACrB;EACA;IACE,eAAe;IACf,0BAA0B;IAC1B,wBAAwB;EAC1B;;EAEA;MACI,WAAW;MACX,mBAAmB;MACnB,gBAAgB;MAChB,8BAA8B;;EAElC;;EAEA;IACE,gBAAgB;IAChB,mBAAmB;IACnB,uBAAuB;IACvB,kCAAkC;IAClC,kBAAkB;EACpB;;EAEA;IACE,gBAAgB;IAChB,iBAAiB;EACnB;;AAEF,mDAAmD;AACnD;IACI;QACI,qCAAqC;IACzC;IACA;MACE,WAAW;EACf;AACF;AACA;IACI;QACI,qCAAqC;IACzC;IACA;MACE,WAAW;EACf;EACA;IACE,gBAAgB;IAChB,aAAa;IACb,cAAc;EAChB;EACA;GACC,WAAW;EACZ;EACA;IACE,0BAA0B;EAC5B;AACF;;AAEA;EACE;IACE,sBAAsB;IACtB,mBAAmB;IACnB,aAAa;IACb,YAAY;AAChB;;AAEA;EACE,aAAa;EACb,YAAY;AACd;AACA;EACE,0BAA0B;AAC5B;AACA;;AAEA;EACE;IACE,qCAAqC;EACvC;AACF","sourcesContent":[".filterWrapper {\n    background-color: #fff;\n    border-radius: 10px;\n    padding: 24px;\n    margin: 24px;\n}\n.filterWrapper >div{\n    display: grid;\n    grid-template-columns: repeat(4, 1fr);\n    gap: 20px 16px;\n}\n\n.dailyAttendanceSheetWrapper{\n  background-color: #fff;\n  border-radius: 10px;\n  padding: 24px;\n  margin: 24px;\n}\n\n.submitBtnWrapper{\n    display: flex;\n    flex-wrap: wrap;\n    justify-content: center;\n    margin: 30px 10px;\n    gap: 16px;\n}\n\n.headerEdit, .headerLogs{\n    display: flex;\n    align-items:center;\n    gap: 12px;\n  }\n  .headerEdit >p{\n    margin-bottom: 0px;\n    font-size: 20px;\n    font-weight: 600;\n  }\n  \n  .headerLogs >p{\n    margin-bottom: 0px;\n    font-size: 20px;\n    font-weight: 600;\n  }\n  \n  .headerEdit >:nth-child(1){\n    width: 36px;\n    height: 36px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    background-color: rgba(24, 144, 255, 0.1);\n    border-radius: 20px;\n  }\n  .headerLogs>:nth-child(2){\n    cursor: pointer;\n    text-decoration: underline;\n    color: var(--supportRed);\n  }\n\n  .tabAccessTableWrapper > table{\n      width: 100%;\n      table-layout: fixed;\n      overflow-x: auto;\n      border-radius: 10px !important;\n\n  }\n\n  .tabAccessTableWrapper > table td {\n    overflow: hidden;\n    white-space: nowrap;\n    text-overflow: ellipsis;\n    border: 1px solid var(--lightBlue);\n    text-align: center;\n  }\n  \n  .tabAccessTableWrapper > table > tbody td {\n    font-weight: 600;\n    padding: 10px 8px;\n  }\n\n/* --------------- Media Query ------------------ */\n@media (max-width:1300px) {\n    .filterWrapper >div{\n        grid-template-columns: repeat(3, 1fr);\n    }    \n    .tabAccessTableWrapper > table{\n      width: 100%;\n  }\n}\n@media (max-width:1000px) {\n    .filterWrapper >div{\n        grid-template-columns: repeat(2, 1fr);\n    }    \n    .tabAccessTableWrapper > table{\n      width: 100%;\n  }\n  .tabAccessTableWrapper {\n    overflow-x: auto;\n    padding: 10px;\n    display: block;\n  }\n  .tabAccessTableWrapper >table{\n   width: 100%;\n  }\n  .tabAccessTableWrapper p{\n    font-size: 14px !important;\n  }\n}\n\n@media (max-width:750px) {\n  .filterWrapper {\n    background-color: #fff;\n    border-radius: 10px;\n    padding: 10px;\n    margin: 10px;\n}\n\n.dailyAttendanceSheetWrapper{\n  padding: 10px;\n  margin: 10px;\n}\n.tabAccessTableWrapper > table > tbody td {\n  font-size: 14px !important;\n}\n}\n\n@media (max-width:450px) {\n  .filterWrapper >div{\n    grid-template-columns: repeat(1, 1fr);\n  }    \n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
